












































import { Component, Vue } from 'vue-property-decorator';
import AppSwitcherEntry from './AppSwitcherEntry.vue';
import type { CompanySetting } from '@/models/companySetting';
import { Getter } from 'vuex-class';
import { goToMainLink, mainLink, nativeLink, ordersLink } from '@/helpers/routing/links';

@Component({
    name: 'AppSwitcher',
    components: {
        AppSwitcherEntry,
    },
})
export default class AppSwitcher extends Vue {
    @Getter('account/companySetting') protected companySetting: CompanySetting;

    private isMenuOpen: boolean = false;
    private isAlreadyLoading: boolean = false;

    private apps: Array<{
        icon: string;
        translationKey: string;
        url: string | (() => string);
    }> = [
        {
            icon: 'fa fa-clipboard-list',
            translationKey: 'native',
            url: () => nativeLink(''),
        },
    ];

    created() {
        if (this.companySetting.feature_orders) {
            this.apps.push({
                icon: 'fa fa-cubes',
                translationKey: 'orders',
                url: () => ordersLink(''),
            });
        }

        this.$watch('isMenuOpen', () => {
            this.isAlreadyLoading = false;
        });

        this.$nextTick(() => {
            this.isAlreadyLoading = false;
        });
    }

    mounted() {
        document.addEventListener('click', this.handleClickOutside);
    }

    beforeDestroy() {
        document.removeEventListener('click', this.handleClickOutside);
    }

    private handleClickOutside(event: MouseEvent) {
        const menu = this.$refs.menu as any;
        if (menu && !menu.contains(event.target as Node) && event.target !== this.$refs.grid_icon) {
            this.closeMenu();
        }
    }

    private openMenu() {
        this.isMenuOpen = true;
    }

    private closeMenu() {
        this.isMenuOpen = false;
    }

    private setLoadingState(state: boolean) {
        this.isAlreadyLoading = state;
    }
}
